export default __webpack_public_path__ + "static/media/favicon.4c6729c5.png";